import styled from 'styled-components';

export const Page = styled.div`
  min-height: 100vh;
  background: #0b0f14;
  color: white;
`;

export const Layout = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  @media (min-width: 1280px) {
    grid-template-columns: 1fr 380px;
  }
`;

export const Main = styled.main`
  min-width: 0;
`;

export const Banner = styled.div`
  position: relative;
  min-height: 240px;
  overflow: hidden;
`;

export const BannerImage = styled.img`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 0.4;
`;

export const BannerContent = styled.div`
  position: relative;
  z-index: 10;
  padding: 2.5rem;
`;

export const BackBtn = styled.button`
  font-size: 0.875rem;
  color: #5ce9ff;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  margin-bottom: 1.5rem;
  transition: color 0.2s;
  &:hover {
    color: #00f7d2;
  }
`;

export const BannerTitle = styled.h1`
  font-size: 1.875rem;
  font-weight: 600;
  margin: 0 0 0.5rem 0;
  color: white;
`;

export const BannerDescription = styled.p`
  margin: 0 0 1.5rem 0;
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.875rem;
`;

export const BannerActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  justify-content: flex-end;
`;

export const BtnPrimary = styled.button`
  padding: 0.5rem 1rem;
  border-radius: 0.5rem;
  background: linear-gradient(to right, #00f7d2, #5ce9ff);
  color: black;
  font-size: 0.875rem;
  font-weight: 500;
  border: none;
  cursor: pointer;
  box-shadow: 0 4px 14px rgba(0, 247, 210, 0.25);
  transition: transform 0.2s, box-shadow 0.2s;
  &:hover {
    transform: scale(1.02);
    box-shadow: 0 6px 20px rgba(0, 247, 210, 0.35);
  }
`;

export const BtnAddLot = styled.button`
  padding: 0.5rem 1rem;
  border-radius: 0.5rem;
  background: linear-gradient(to right, #a855f7, #6366f1);
  color: white;
  border: none;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  &:hover {
    transform: scale(1.05);
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1);
  }
`;

export const BtnSecondary = styled.button`
  padding: 0.5rem 1rem;
  border-radius: 0.5rem;
  border: 1px solid rgba(0, 247, 210, 0.6);
  color: #00f7d2;
  font-size: 0.875rem;
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(8px);
  cursor: pointer;
  transition: background 0.2s, box-shadow 0.2s;
  &:hover {
    background: rgba(0, 247, 210, 0.1);
    box-shadow: 0 0 15px rgba(0, 247, 210, 0.25);
  }
`;

export const BtnSecondaryCyan = styled(BtnSecondary)`
  border-color: rgba(92, 233, 255, 0.6);
  color: #5ce9ff;
  &:hover {
    background: rgba(92, 233, 255, 0.1);
    box-shadow: 0 0 15px rgba(92, 233, 255, 0.25);
  }
`;

export const Content = styled.div`
  padding: 2.5rem 2.5rem 4rem 2.5rem;
`;

export const ProductsHeader = styled.div`
  margin-bottom: 1.5rem;
`;

export const ProductsTitle = styled.h2`
  font-size: 1.25rem;
  font-weight: 600;
  margin: 0 0 1rem 0;
  color: white;
`;

/* One line: left cluster | space-between | right cluster, tops aligned */
export const InventoryHeaderRow = styled.div`
  display: flex;
  flex-wrap: nowrap;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  width: 100%;
`;

export const InventoryLeft = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 1rem;
  flex: 0 1 auto;
  min-width: 0;
`;

export const InventoryRight = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex: 0 0 auto;
`;

export const CountBadge = styled.span`
  font-size: 0.75rem;
  padding: 0.25rem 0.75rem;
  border-radius: 9999px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: #111827;
  color: #5ce9ff;
  &.empty {
    background: rgba(239, 68, 68, 0.2);
    border-color: rgba(239, 68, 68, 0.4);
    color: #f87171;
  }
`;

export const LastUpdate = styled.span`
  font-size: 0.75rem;
  color: #9ca3af;
`;

export const SearchRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
`;

export const SearchWrap = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
`;

export const SearchIconWrap = styled.span`
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  width: 18px;
  height: 18px;
  pointer-events: none;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #5ce9ff;
  opacity: 0.9;
`;

export const SearchInput = styled.input`
  width: 16rem;
  min-width: 12rem;
  background: #111827;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 0.75rem;
  padding: 0.5rem 2.5rem 0.5rem 2.5rem;
  color: white;
  font-size: 0.875rem;
  outline: none;
  transition: border-color 0.2s, box-shadow 0.2s;
  &::placeholder {
    color: #6b7280;
  }
  &:focus {
    border-color: rgba(255, 255, 255, 0.2);
    box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.08);
  }
`;

export const SearchClear = styled.button`
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 0.75rem;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  background: rgba(239, 68, 68, 0.2);
  border: 1px solid rgba(239, 68, 68, 0.4);
  color: #f87171;
  cursor: pointer;
`;

export const FilterRow = styled.div`
  display: inline-flex;
  align-items: stretch;
  gap: 0;
  padding: 3px;
  border-radius: 0.75rem;
  background: rgba(17, 24, 39, 0.9);
  border: 1px solid rgba(255, 255, 255, 0.08);
`;

const getActiveFilterGradient = (filterValue) => {
  switch (filterValue) {
    case 'products':
      return 'linear-gradient(to right, #00f7d2, #5ce9ff)';
    case 'groups':
      return 'linear-gradient(to right, #10b981, #34d399)';
    case 'auction':
      return 'linear-gradient(to right, #FF7B00, #FFC107)';
    case 'lots':
      return 'linear-gradient(to right, #975AFF, #6B4DFE)';
    default:
      return 'linear-gradient(to right, #00f7d2, #5ce9ff)';
  }
};

export const FilterBtn = styled.button`
  padding: 0.375rem 1rem;
  border: none;
  outline: none;
  box-shadow: none;
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: 500;
  transition: all 0.2s;
  background: ${(p) => (p.$active ? getActiveFilterGradient(p.$filterValue) : 'transparent')};
  color: ${(p) => (p.$active ? '#fff' : '#a0a0a0')};
  border-radius: 0;

  &:first-of-type {
    border-radius: 0.5rem 0 0 0.5rem;
  }
  &:last-of-type {
    border-radius: 0 0.5rem 0.5rem 0;
  }
  &:only-of-type {
    border-radius: 0.5rem;
  }

  ${(p) => p.$active && 'border-radius: 0.5rem !important;'}

  &:hover {
    color: ${(p) => (p.$active ? '#fff' : 'rgba(255, 255, 255, 0.9)')};
    background: ${(p) => (p.$active ? getActiveFilterGradient(p.$filterValue) : 'rgba(255, 255, 255, 0.06)')};
  }
`;

export const ViewToggle = styled.div`
  display: flex;
  gap: 0.25rem;
  font-size: 0.75rem;
  background: rgba(255, 255, 255, 0.05);
  padding: 0.25rem;
  border-radius: 0.75rem;
  border: 1px solid rgba(255, 255, 255, 0.1);
`;

export const ViewToggleBtn = styled.button`
  padding: 0.375rem 1rem;
  border-radius: 0.5rem;
  border: none;
  cursor: pointer;
  font-size: 0.75rem;
  transition: all 0.2s;
  background: ${(p) => (p.$active ? 'linear-gradient(to right, #00f7d2, #5ce9ff)' : 'transparent')};
  color: ${(p) => (p.$active ? 'black' : 'rgba(255, 255, 255, 0.6)')};
  box-shadow: ${(p) => (p.$active ? '0 2px 8px rgba(0, 247, 210, 0.3)' : 'none')};
  &:hover {
    color: ${(p) => (p.$active ? 'black' : 'white')};
  }
`;

export const ProductList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const ProductListRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem 1rem;
  border-radius: 0.75rem;
  background: linear-gradient(to right, rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0));
  border: 1px solid rgba(255, 255, 255, 0.1);
  cursor: pointer;
  transition: border-color 0.2s, background 0.2s;
  &:hover {
    border-color: rgba(0, 247, 210, 0.6);
  }
  &.selected {
    border-color: #00f7d2;
    background: rgba(0, 247, 210, 0.05);
    box-shadow: 0 0 25px rgba(0, 247, 210, 0.35);
  }
`;

export const ProductListLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
`;

export const ProductThumb = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 6px;
  object-fit: cover;
  background: rgba(255, 255, 255, 0.05);
`;

export const ProductListInfo = styled.div``;

export const ProductListName = styled.div`
  font-weight: 500;
  color: white;
`;

export const ProductListMeta = styled.div`
  font-size: 0.75rem;
  color: rgba(255, 255, 255, 0.5);
`;

export const GroupBadge = styled.span`
  display: inline-block;
  padding: 2px 8px;
  font-size: 10px;
  font-weight: 700;
  border-radius: 9999px;
  background: linear-gradient(180deg, #8b5cf6, #a78bfa);
  color: #fff;
  box-shadow: 0 0 12px rgba(139, 92, 246, 0.8);
  text-transform: uppercase;
  letter-spacing: 0.02em;
`;

export const ProductListRight = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
`;

export const ProductPrice = styled.span`
  font-size: 0.875rem;
  color: #5ce9ff;
`;

export const BtnSmall = styled.button`
  padding: 0.25rem 0.75rem;
  font-size: 0.75rem;
  border-radius: 0.5rem;
  border: none;
  cursor: pointer;
  transition: opacity 0.2s, transform 0.2s;
  &:hover {
    opacity: 0.9;
  }
`;

export const BtnClone = styled(BtnSmall)`
  border: 1px solid rgba(168, 85, 247, 0.4);
  color: #c4b5fd;
  background: rgba(168, 85, 247, 0.1);
`;

export const BtnView = styled(BtnSmall)`
  border: 1px solid rgba(255, 255, 255, 0.2);
  background: rgba(255, 255, 255, 0.05);
  color: white;
`;

export const BtnBuy = styled(BtnSmall)`
  background: linear-gradient(to right, #00f7d2, #5ce9ff);
  color: black;
  font-weight: 500;
`;

export const BtnGroup = styled(BtnSmall)`
  border: 1px solid rgba(0, 247, 210, 0.6);
  color: #00f7d2;
  background: rgba(255, 255, 255, 0.05);
`;

export const BtnAction = styled(BtnSmall)`
  border: 1px solid rgba(92, 233, 255, 0.6);
  color: #5ce9ff;
  background: rgba(255, 255, 255, 0.05);
`;

export const TimerBadge = styled.span`
  margin-left: 0.5rem;
  padding: 0.125rem 0.5rem;
  font-size: 10px;
  border-radius: 9999px;
  background: rgba(239, 68, 68, 0.2);
  color: #f87171;
  border: 1px solid rgba(239, 68, 68, 0.4);
`;

/** Auction end time button: teal fill, black text, glow. Use for "Auction · DD:HH:MM:SS" */
export const AuctionTimerBtn = styled.button`
  padding: 0.4rem 0.9rem;
  border-radius: 9999px;
  border: none;
  font-size: 0.75rem;
  font-weight: 600;
  cursor: pointer;
  background: linear-gradient(135deg, #00f7d2 0%, #5ce9ff 100%);
  color: #0b0f14;
  box-shadow: 0 0 20px rgba(0, 247, 210, 0.4);
  transition: box-shadow 0.2s, transform 0.2s;
  white-space: nowrap;
  &:hover {
    box-shadow: 0 0 28px rgba(0, 247, 210, 0.55);
    transform: scale(1.02);
  }
`;

/** Group end time button: purple fill, white text, glow. Use for "Join Group · DD:HH:MM:SS" */
export const GroupTimerBtn = styled.button`
  padding: 0.4rem 0.9rem;
  border-radius: 9999px;
  border: none;
  font-size: 0.75rem;
  font-weight: 600;
  cursor: pointer;
  background: linear-gradient(135deg, #7c3aed 0%, #a78bfa 100%);
  color: white;
  box-shadow: 0 0 20px rgba(124, 58, 237, 0.45);
  transition: box-shadow 0.2s, transform 0.2s;
  white-space: nowrap;
  &:hover {
    box-shadow: 0 0 28px rgba(124, 58, 237, 0.6);
    transform: scale(1.02);
  }
`;

export const ProductGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 1.5rem;
`;

export const ProductCard = styled.div`
  border-radius: 1rem;
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0));
  border: 1px solid rgba(255, 255, 255, 0.1);
  overflow: hidden;
  cursor: pointer;
  transition: border-color 0.2s, box-shadow 0.2s;
  &:hover {
    border-color: rgba(0, 247, 210, 0.6);
    box-shadow: 0 0 30px rgba(0, 247, 210, 0.15);
  }
  &.selected {
    border-color: #00f7d2;
    box-shadow: 0 0 30px rgba(0, 247, 210, 0.3);
  }
`;

export const ProductCardImage = styled.div`
  position: relative;
  height: 176px;
  width: 100%;
  background: rgba(255, 255, 255, 0.05);
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const ProductCardImageBadge = styled(GroupBadge)`
  position: absolute;
  top: 8px;
  left: 8px;
`;

export const ProductCardBody = styled.div`
  padding: 1rem;
`;

export const ProductCardTitle = styled.h4`
  font-weight: 500;
  margin: 0 0 0.25rem 0;
  color: white;
`;

export const ProductCardMeta = styled.div`
  font-size: 0.75rem;
  color: rgba(255, 255, 255, 0.5);
`;

export const ProductCardActions = styled.div`
  margin-top: 1rem;
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
`;

export const NoResults = styled.div`
  font-size: 0.875rem;
  color: #f87171;
`;

export const Sidebar = styled.aside`
  border-left: 1px solid rgba(255, 255, 255, 0.1);
  background: #0e141b;
  padding: 2rem;
  overflow-y: auto;
  @media (min-width: 1280px) {
    position: sticky;
    top: 0;
    max-height: 100vh;
  }
`;

export const SidebarTitle = styled.h3`
  font-size: 1.125rem;
  font-weight: 600;
  margin: 0 0 1.5rem 0;
  color: white;
`;

export const InfoBlock = styled.div`
  margin-bottom: 1rem;
`;

export const InfoLabel = styled.div`
  font-size: 0.75rem;
  color: rgba(255, 255, 255, 0.5);
  margin-bottom: 0.25rem;
`;

export const InfoValue = styled.div`
  font-size: 0.875rem;
  color: white;
`;

export const AddressCard = styled.div`
  margin-top: 2.5rem;
  border-radius: 0.75rem;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(255, 255, 255, 0.05);
  padding: 1rem;
  font-size: 0.875rem;
  line-height: 1.5;
  color: white;
`;

export const MapWrap = styled.div`
  margin-top: 2.5rem;
  border-radius: 0.75rem;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.1);
  iframe {
    width: 100%;
    height: 192px;
    display: block;
  }
`;

export const DocList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  margin-top: 2.5rem;
`;

export const DocItem = styled.li`
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 0.5rem;
  padding: 0.75rem;
  background: rgba(255, 255, 255, 0.05);
  margin-bottom: 0.75rem;
`;

export const DocLink = styled.a`
  font-size: 0.75rem;
  padding: 0.25rem 0.75rem;
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.1);
  color: white;
  text-decoration: none;
  display: inline-block;
  margin-top: 0.5rem;
  transition: background 0.2s;
  &:hover {
    background: rgba(255, 255, 255, 0.2);
  }
`;

export const LoadingOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

export const ProductDetailGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 2rem;
  margin-top: 1.5rem;
  @media (min-width: 768px) {
    grid-template-columns: 1fr 1fr;
  }
`;

/* Lot-specific styles */
export const LotCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  padding: 0.75rem 1rem;
  border-radius: 0.75rem;
  background: linear-gradient(to right, rgba(168, 85, 247, 0.1), rgba(99, 102, 241, 0.05));
  border: 1px solid rgba(168, 85, 247, 0.4);
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s, border-color 0.2s;
  @media (min-width: 640px) {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
  &:hover {
    transform: scale(1.02);
    box-shadow: 0 4px 12px rgba(168, 85, 247, 0.3);
  }
  &.selected {
    border-color: rgba(168, 85, 247, 0.8);
    box-shadow: 0 0 25px rgba(168, 85, 247, 0.4);
  }
`;

export const LotCardContent = styled.div`
  flex: 1;
  min-width: 0;
`;

export const LotCardHeader = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 0.25rem;
`;

export const LotNumber = styled.div`
  color: #c4b5fd;
  font-weight: 600;
  font-size: 0.875rem;
`;

export const LotProductName = styled.div`
  color: #5ce9ff;
  font-weight: 500;
  font-size: 0.875rem;
`;

export const AssociatedBadge = styled.span`
  padding: 2px 8px;
  font-size: 10px;
  border-radius: 9999px;
  background: rgba(0, 247, 210, 0.2);
  color: #00f7d2;
  border: 1px solid rgba(0, 247, 210, 0.4);
  font-weight: 500;
`;

export const LotCardMeta = styled.div`
  font-size: 0.75rem;
  color: rgba(255, 255, 255, 0.5);
  margin-top: 0.25rem;
`;

export const LotCardActions = styled.div`
  display: flex;
  gap: 0.5rem;
  flex-shrink: 0;
`;

export const BtnTrace = styled(BtnSmall)`
  background: linear-gradient(to right, #a855f7, #6366f1);
  color: white;
  font-weight: 500;
  box-shadow: 0 2px 8px rgba(168, 85, 247, 0.3);
  &:hover {
    box-shadow: 0 4px 12px rgba(168, 85, 247, 0.4);
  }
`;
